import {proxy} from "ajax-hook";
class NpmHookSdkBase{
    constructor(){
    }
}

class NpmHookSdkSentry extends NpmHookSdkBase{
  //私有化属性
  #connection=navigator.connection || navigator.mozConnection  || navigator.webkitConnection;
  #timeObj=null;
  #HookAppErrorList=[];
  #sdkConfig={
    appMenage:{
      menage:"NpmHookSdk SDK Template",
      version:"0.1"
    } 
  }
  constructor(config){
    super();
    this.config=config;
    this.config.httpCodes=this.config.httpCodes||[200];
    this.initSdk((res)=>{
      //初始化js错误异常监听
      this.addListeners();
      //初始化ajax异常监听
      this.initAjaxProxy();
      //初始化数据
      this.loadData();
      //初始化暴露外部的函数
      this.bindFuns();
      if(typeof(config.success)=="function"){
        config.success(res);
      }
      this.#timeObj=setInterval(() => {
        if(this.#HookAppErrorList.length>0){
           this.postError(this.#HookAppErrorList[0]);
        }
      }, config.timeNum||5000);
    },(error)=>{
      if(typeof(config.error)=="function"){
        config.error(new Error(`注册异常${JSON.stringify(error)}`));
      }
   })
  }
  /**注册外部事件 */
  bindFuns(){
    /***
     * 设置唯一标识字段
     * @param {*} uuid  uuid
     */
    this.setUserInfo=(uuid)=>{
      if(uuid){
        this.config.userInfo=uuid;
      }
    }
    /**
     * 关闭监听
     */
    this.stopWatch=()=>{
      this.config.start=false;
    }
     /**
      * 开启监听
      */
    this.startWatch=()=>{
      this.config.start=true;
    }
    /**
     * 外部主动上报错误
     * @param {*} type  错误类型
     * @param {*} error 错误对象
     */
    this.saveError=(type,error)=>{
      return new Promise((resolve)=>{
        let errorObj=error;
        if(type==="ajax"){
          errorObj={
            response:this.ToString(error.response||{}),
            config:this.ToString({
              url:error.url||"",
              body:error.body||{}
            })
          };
        }
        this.addError(errorObj,type,()=>{
          resolve();
        });
      })
    }
  }
  /***
   * 初始化数据
   */
   loadData(){
    this.#HookAppErrorList=localStorage.getItem("HookAppErrorList")?
    JSON.parse(localStorage.getItem("HookAppErrorList")):[];
   }
   /*注册监听*/
   addListeners(){
    //根据返回的监听配置注册对应的监听事件，我这里全部写上了
    window.addEventListener("error", (event)=>{
        this.addError(event,"js");
        event.preventDefault();
    },true);
    window.addEventListener("unhandledrejection", (err) => {
        this.addError(err||{},"ajax");
    });
    window.addEventListener('unload',()=>{
      //卸载的时候需要把数据上报上去，具体看自己怎么传数据
      if(this.#HookAppErrorList.length>0){
        this.ajax(this.#HookAppErrorList[0]);
      }
      clearTimeout(this.#timeObj);
    },false);
   }
   ToString(json){
     return JSON.stringify(json);
   }
  /*组装ajax异常
  * @param event object  错误对象
  */
   getAjaxError(event){
   return {
      xhrUrl:event.config.url,
      dataSend:event.config.body,
      errorObj:event.response
    }
   }
    /*收集异常
    * @param event object  错误对象
    */
   getCodeError(event){
     if(event.target){
      if(event.target.nodeName==="IMG"){
        event.message=`{'msg':'图片路径错误','data':${event.target.currentSrc}}`
      }
     }
      return {
        jsPath:event.filename,
        errorObj:this.ToString({
          message:event.error?event.error.message:event.message,
          stack:event.error?event.error.stack:event.stack,
        })
      }
   }
    /*组装业务代码异常
    * @param event object  错误对象
    * @param type  string  错误类型
    */
    getErrorObj(event,type){
    // 错误类型：0：前端异常，1：接口异常
    const errObj=type==="ajax"?this.getAjaxError(event):this.getCodeError(event);
    const types={ajax:1,js:0};
    return Object.assign({
        appKey:this.config.appkey,
        userInfo:this.config.userInfo,
        url:document.location.href,
        browser:navigator.userAgent,
        browserVersion:navigator.appVersion,
        appVersion:this.#sdkConfig.appMenage.version,
        system:navigator.platform,
        referer:document.referrer,
        errorType:types[type],
        connection:this.#connection.effectiveType
     },errObj)
    }
    /*注册ajax 代理拦截*/
    initAjaxProxy(){
      let getErrorCode=(obj,defaultVal)=>{
        let length=0;
        let result="";
        let httpErrorKeyName=this.config.httpErrorKeyName;
        let getCode=()=>{
          if(length>=3){
            return result;
          }
          for (var key in obj) {
            if(key==httpErrorKeyName){
              result= obj[key];
              break;
            }
            if (typeof (obj[key]) == "object") {
              length++;
              getCode(obj[key]);
            }
          }
        }
        getCode(obj);
        return result||defaultVal
      }
      proxy({
        //请求发起前进入
        onRequest: (config, handler) => {
         handler.next(config);
        },
        //请求发生错误时进入，比如超时；注意，不包括http状态码错误，如404仍然会认为请求成功
        onError: (err, handler) => {
          handler.next(err)
        },
        //请求成功后进入
        onResponse: (res, handler) => {
          try {
            let codeValue=res.status;
            if(this.config.start){
              let isError= false;
              if(this.config.httpValidateError&&typeof(this.config.httpValidateError)=="function"){
                isError=this.config.httpValidateError(res);
              }else{
                if(this.config.httpErrorKeyName){
                  let response="";
                  try {
                    response=JSON.parse(res.response?res.response:res);
                  } catch (error) {
                    response=res
                  }
                  codeValue=getErrorCode(response,codeValue);
                }
                isError= this.config.httpCodes.includes(codeValue)==false;
              }
              if(isError){
                this.addError(res,"ajax");
              }
              if(this.config.httpCodes.includes(codeValue)==false){
                this.addError(res,"ajax");
              }
            }
          } catch (error) {
          }
          handler.next(res)
        }
      })
    }
    /*发送上报数据
    * @param param  object    错误对象
    * @param ()     function  成功函数
    * @param ()     function  错误对象
    */
    ajax(param,success, fail){
      if(navigator.sendBeacon&&typeof(navigator.sendBeacon)==="function"){
        let res=navigator.sendBeacon(this.config.api+"/error/add",this.ToString(param));
        if(res){
          success(res)
        }else{
          fail(res);
        }
      }
      else{
        let img = new Image();
        img.onload =function (res){
            success(res);
        }
        img.onerror=function(res){
            fail(res);
        }
        img.src = this.config.api+`?data=`+encodeURI(this.ToString(param));
      }
    }
    /*代码异常
    * @param param  object    错误对象
    * @param type   string    错误类型
    */
    addError(event,type,back){
      if(this.config.start){
        let error=this.getErrorObj(event,type);
        let isExis=this.#HookAppErrorList.find((item)=>{
          return error.errorObj==item.errorObj
        })
        if(!isExis){
          let otherInfo=this.config.otherInfo||this.#connection;
          this.#HookAppErrorList.push(Object.assign(error,{otherInfo:this.ToString(otherInfo)}));
          localStorage.setItem("HookAppErrorList",this.ToString(this.#HookAppErrorList));
          console.log(localStorage.HookAppErrorList)
        }
        if(back)back();
      }
    }
    /*最终的上报错误
    * @param obj  object    错误信息对象
    */
    postError(obj){
      this.ajax(obj,()=>{
        this.#HookAppErrorList.shift();
        localStorage.setItem("HookAppErrorList",this.ToString(this.#HookAppErrorList));
      },()=>{
        console.error(new Error("错误收集服务异常"))
      })
    }
    /*注册sdk
    * @param config  object    错误对象
    * @param success function  成功函数
    * @param fail    function  错误函数
    */
    initSdk(success,fail){
        let xmlHttp = window.XMLHttpRequest ? 
        new XMLHttpRequest() 
        : new ActiveXObject('Microsoft.XMLHTTP');
        xmlHttp.open("get",`${this.config.api}/app/verify?appKey=${this.config.appkey}`, true);
        xmlHttp.setRequestHeader('Content-Type','application/json;charset=UTF-8');
        xmlHttp.onreadystatechange = function () {
          if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
            let res = JSON.parse(xmlHttp.responseText);
            if(res.code==200){
              success(res);
            }else{
              fail(res);
            }
          }
       };
       xmlHttp.send(this.ToString({appkey:this.config.appkey}));
    }
}

(function(){
  window.NpmHookSdkSentry=NpmHookSdkSentry
})()

